
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";

const app = namespace("app");
const finance = namespace("finance");

@Component({
  components: { TableEnableFlag, StandardFlag }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("marketing.please-select-card-template"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class CustomerEditxxx extends Vue {
  @app.State btnLoading;
  @finance.Action getCustomerUnpaidOrder;
  @finance.State onAccountManageRow;
  dayjs = dayjs;
  @app.Mutation setPBPX;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  searchForm = {};
  orderList: any[] = [];
  row: any = {};
  // 计算金额
  get actuallyAmount() {
    return this.totalOrderAmount;
  }
  get totalOrder() {
    return [].concat(this.mix_selectedRows).length;
  }
  get totalOrderAmount() {
    let totalList = [].concat(this.mix_selectedRows);
    try {
      return totalList
        .reduce((prev, curv) => {
          return (prev || 0) + Number(curv.orderAmount || 0);
        }, 0)
        .toFixed(2);
    } catch (e) {
      return 0;
    }
  }
  get searchList() {
    return [
      {
        label: t("test.keyword"),
        type: "input",
        value: "",
        prop: "searchKey",
        placeholder: t("test.license-name-mobile-vincode")
      }
    ];
  }
  get breadData() {
    return [
      { name: t("finance.payment-management"), path: "/finance/on-account-manage" },
      { name: t("finance.chargeable-details") }
    ];
  }
  form = {
    name: ""
  };
  created() {
    this.setPBPX(100);
    console.log(JSON.parse(sessionStorage.getItem("onAccountId")));
    this.row = this.$route.params.row || JSON.parse(sessionStorage.getItem("onAccountId"));
    this.loadListData();
  }
  toggleSelection() {
    this.$nextTick(() => {
      const ref = this.$refs as any;
      ref.table.toggleAllSelection();
    });
  }
  loadListData() {
    return this.getCustomerUnpaidOrder({
      customerCode: this.row.customerCode || this.onAccountManageRow.customerCode,
      settlementStatus: 2
    }).then(data => {
      this.orderList = data.data;
      this.toggleSelection();
      return data;
    });
  }
  returnBack() {
    this.$router.push("/finance/on-account-manage");
  }
  goToCashier() {
    this.$router.push({
      name: "serviceCashier",
      params: {
        id: this.mix_selectedRows[0].orderNo,
        orderList: this.mix_selectedRows as any,
        onAccountTo: "true",
        row: this.$route.params.row
      }
    });
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  // ---------------------------
}
